import request from './services/axios.js'

export default {
  getVipMsn: (params) => {
    return request({
      params,
      url: '/ebook/getAuthorizeByUsername',
      method: 'get'
    })
  },
  // 获取电子书刊会员VIP商品信息
  getMemberVipProInfo: () => {
    return request({
      url: '/ebook/getMemberVipProInfo',
      method: 'GET'
    })
  },
  // 生成电子书刊会员VIP订单信息
  getMemberOrder: (params) => {
    return request({
      data: params,
      url: '/buy/ebookMemberVIP.jhtml',
      method: 'POST'
    })
  },
  // 获取电子书刊商品信息(会员和空间)
  getMemberProInfo: (params) => {
    return request({
      params,
      url: '/ebook/getMemberProInfo',
      method: 'GET'
    })
  },
  // 生成储存空间商品订单信息
  getEbookMemberSpaceOrder: (params) => {
    return request({
      data: params,
      url: '/buy/ebookMemberSpace.jhtml',
      method: 'POST'
    })
  },
  // 空间权限信息
  getSpaceAuthorize: (params) => {
    return request({
      params,
      url: '/ebook/getSpaceAuthorize',
      method: 'GET'
    })
  },
  // 获取会员权益
  getVipRight: (params) => {
    return request({
      params,
      url: '/ebook/queryRight',
      method: 'GET'
    })
  },
  getVipRightByUsername: (params) => {
    return request({
      params,
      url: '/ebook/queryRightByName',
      method: 'GET'
    })
  },
  getAuthenUserByLoginName: () => {
    return request({
      url: '/ebook/authen/getAuthenUserByLoginName',
      method: 'GET'
    })
  }
}
